import { useEffect, useState } from 'react';
import { isDesktop } from 'react-device-detect';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Header from '../../components/Header/Header';
import axiosClient from '../../libs/axiosClient';
import { IBasketDataType, IBasketProductType } from '../Basket/Basket';
import styles from './Questionnaire.module.scss';
import { useTranslation } from 'react-i18next';
import lineIDFind from '../../assets/lineIDFind.png';
const telRegex = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;
const registrationNumberRegex =
  /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))-[1-8][0-9]{6}$/;
const nameRegex = /^[ㄱ-ㅎ가-힣a-zA-Z\s]+$/;
const birthRegex = /^[0-9]{8}$/;

interface ISavedPatientType {
  line_id?: string;
  caffeine_sensitivity: number;
  daily_coffee_intake: number;
  diet_pills_experience: string;
  diet_pills_level: number;
  diet_pills_side_effects: string | null;
  disease: null | string;
  height: number;
  is_disease: string;
  is_pregnant: string;
  is_taking_medicines: string;
  phone: string;
  taking_medicines: null | string;
  user_name: string;
  weight: number;
  social_number: number;
}
function Questionnaire() {
  const navigate = useNavigate();
  const { cartId } = useParams();
  const { isDirect } = useParams();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [orderData, setOrderData] = useState<IBasketDataType>();
  useEffect(() => {
    if (!cartId || !isDirect) return;
    let itemIdList: number[] = JSON.parse(cartId);
    let queryString = `is_direct=${isDirect}`;
    itemIdList.map((id) => {
      queryString += `&cart_ids=${id}`;
    });
    axiosClient.get(`/data/cart?${queryString}`).then((res) => {
      setOrderData(res.data.data);
    });
  }, []);
  function productOptionCal(product: IBasketProductType) {
    let data = { price: 0, count: 0 };
    product.items.map((option) => {
      data.price += option.discount_price * option.count;
      data.count += option.count;
    });
    return data;
  }
  const onSubmit = async (data: any) => {
    if (isSubmitting) return;
    if (!birthRegex.test(watch().patientBirth))
      return alert(t('questionnaire.58'));

    setIsSubmitting(true);
    let formData = new FormData();
    let date = new Date();
    let year = date.getFullYear();
    let age = year - watch().patientBirth.slice(0, 4);
    let ageFormat = age > 0 && age <= 99 ? age.toString() : '99';
    // formData.append('line_id', watch().lineId);
    formData.append('line_id', '');
    formData.append('user_name', watch().patientName);
    formData.append('phone', watch().patientTel);
    formData.append('social_number', watch().patientBirth);
    formData.append('age', ageFormat);
    formData.append('height', watch().patientHeight);
    formData.append('weight', watch().patientWeight);
    formData.append('is_pregnant', watch().pregnancy ? 'Y' : 'N');
    formData.append('daily_coffee_intake', String(watch().dailyCoffee));
    formData.append(
      'caffeine_sensitivity',
      String(watch().caffeineSensitivity),
    );
    watch().dietPillsExperience.map((val: boolean, idx: number) => {
      if (val) formData.append('diet_pills_experience', String(idx + 1));
    });
    if (!watch().dietPillsExperience[0]) {
      formData.append('diet_pills_level', String(watch().dietPillsLevel));
      formData.append(
        'diet_pills_side_effects',
        String(watch().sideEffects || ''),
      );
    }
    formData.append('is_disease', watch().disease ? 'Y' : 'N');
    formData.append(
      'disease',
      watch().disease ? watch().diseaseDetail || '' : '',
    );
    formData.append('is_taking_medicines', watch().medicine ? 'Y' : 'N');
    formData.append(
      'taking_medicines',
      watch().medicine ? watch().medicineDetail || '' : '',
    );
    await axiosClient.post('/func/prescription', formData).then((res) => {
      navigate(`/order/${isDirect}/${cartId}`, {
        state: {
          // lineId: watch().lineId,
          patientName: watch().patientName,
          patientTel: watch().patientTel,
          patientSecurityNumber1: watch().patientSecurityNumber1,
          patientSecurityNumber2: watch().patientSecurityNumber2,
          patientBirth: watch().patientBirth,
          patientAge: age > 0 && age <= 99 ? age.toString() : '99',
          patientHeight: watch().patientHeight,
          patientWeight: watch().patientWeight,
          reason: watch().reason,
          pregnancy: watch().pregnancy,
          dailyCoffee: watch().dailyCoffee,
          caffeineSensitivity: watch().caffeineSensitivity,
          dietPillsExperience: watch().dietPillsExperience,
          dietPillsLevel: watch().dietPillsLevel,
          sideEffects: watch().sideEffects || '',
          disease: watch().disease,
          medicine: watch().medicine,
          diseaseDetail: watch().diseaseDetail || '',
          medicineDetail: watch().medicineDetail || '',
        },
      });
    });
    setIsSubmitting(false);
  };
  const onSubmitError = (error: any) => {
    let errorList: { message: string }[] = Object.values(error);
    alert(errorList[0].message);
  };

  useEffect(() => {
    axiosClient.get('/data/prescription').then((res) => {
      let result: ISavedPatientType = res.data.data;
      console.log(result);
      if (Object.keys(result).length == 0) return;
      // setValue('lineId', result.line_id || '');
      if (nameRegex.test(result.user_name))
        setValue('patientName', result.user_name);
      setValue('patientTel', result.phone.trim().replace(/-/g, ''));
      setValue('patientBirth', String(result.social_number || ''));
      setValue('patientHeight', String(result.height));
      setValue('patientWeight', String(result.weight));
      setValue('pregnancy', result.is_pregnant == 'Y' ? true : false);
      setValue('dailyCoffee', result.daily_coffee_intake);
      setValue('caffeineSensitivity', result.caffeine_sensitivity);
      setValue(
        'dietPillsExperience',
        (() => {
          let newVal = [false, false, false, false];
          result.diet_pills_experience.split(',').map((num: string) => {
            newVal[Number(num) - 1] = true;
          });
          return newVal;
        })(),
      );
      setValue('dietPillsLevel', result.diet_pills_level);
      setValue('sideEffects', result.diet_pills_side_effects || '');
      setValue('disease', result.is_disease == 'Y' ? true : false);
      setValue('diseaseDetail', result.disease || '');
      setValue('medicine', result.is_taking_medicines == 'Y' ? true : false);
      setValue('medicineDetail', result.taking_medicines || '');
    });
  }, []);
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      {isDesktop && <Header />}
      <div className={styles.contentArea}>
        <div className={styles.left}>
          <h2>{t('questionnaire.1')}</h2>
          <div className={styles.productListWrap}>
            {orderData?.carts.map((company) =>
              company.cart.map((product) => (
                <div
                  className={styles.productInfoWrap}
                  key={product.product.product_id}
                >
                  <div className={styles.thumbnailWrap}>
                    <img src={product.product.list_image} alt="thumbnail" />
                  </div>
                  <div className={styles.productInfo}>
                    <h3 className={styles.productName}>
                      {product.product.title}
                    </h3>
                    <ul className={styles.optionList}>
                      {product.product.option_depth > 0 &&
                        product.items.map((option) => (
                          <li key={option.id}>
                            <span>
                              {option.option1 && option.option1}
                              {option.option2 && ' / ' + option.option2}
                              {option.option3 && ' / ' + option.option3}
                            </span>
                            <span>
                              {t('questionnaire.35')} {option.count}
                            </span>
                          </li>
                        ))}
                    </ul>
                    <div className={styles.totalInfoWrap}>
                      {(() => {
                        let res = productOptionCal(product);
                        return (
                          <>
                            <span>${res.price.toLocaleString()}</span>
                            <span>
                              {t('questionnaire.35')} {res.count}
                            </span>
                          </>
                        );
                      })()}
                    </div>
                  </div>
                </div>
              )),
            )}
          </div>
          <div className={styles.questionnaireWrap}>
            <form
              className={styles.questionnaireForm}
              onSubmit={(e) => e.preventDefault()}
            >
              {/* <div className={styles.lineFindImgWrap}>
                <img src={lineIDFind} alt="lineIDFind" />
              </div> */}
              {/* lineid */}
              {/* <label className={`${styles.label} ${styles.nameLabel}`}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>ラインID</span>
                </div>
                <div
                  className={`${styles.inputWrap} ${
                    errors.lineId ? styles.validationError : ''
                  }`}
                >
                  <input
                    type="text"
                    // placeholder={`${t('questionnaire.2')}`}
                    className={`${styles.normalInput} name`}
                    {...register('lineId', {
                      required: {
                        value: true,
                        message: 'ラインIDを入力してください。',
                      },
                    })}
                  />
                </div>
              </label> */}
              {/* lineid */}

              <label className={`${styles.label} ${styles.nameLabel}`}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>{t('questionnaire.2')}</span>
                </div>
                <div
                  className={`${styles.inputWrap} ${
                    errors.patientName ? styles.validationError : ''
                  }`}
                >
                  <input
                    type="text"
                    placeholder={`${t('questionnaire.2')}`}
                    className={`${styles.normalInput} name`}
                    {...register('patientName', {
                      value: '',
                      required: {
                        value: true,
                        message: t('questionnaire.42'),
                      },
                      pattern: {
                        value: nameRegex,
                        message: t('questionnaire.43'),
                      },
                    })}
                  />
                </div>
                {/* <p>한글, 영문, 공백만 사용 가능합니다.</p> */}
              </label>
              <label className={styles.phoneNumberLabel}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>{t('questionnaire.3')}</span>
                </div>
                <div className={styles.box}>
                  <div
                    className={`${styles.phoneNumberInuptWrap} ${
                      errors.patientTel ? styles.validationError : ''
                    }`}
                  >
                    <input
                      type="text"
                      placeholder=""
                      className={`${styles.normalInput} tel`}
                      {...register('patientTel', {
                        value: '',
                        required: {
                          value: true,
                          message: t('questionnaire.44'),
                        },
                        minLength: {
                          value: 10,
                          message: t('questionnaire.45'),
                        },
                        onChange: (e) => {
                          let value = e.currentTarget.value;
                          if (!/^[0-9]+$/g.test(value)) {
                            setValue(
                              'patientTel',
                              value.slice(0, value.length - 1),
                            );
                          }
                        },
                      })}
                    />
                  </div>
                  <p>{t('questionnaire.4')}</p>
                </div>
              </label>

              <label className={styles.label}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>Birth</span>
                </div>
                <div
                  className={`${styles.inputWrap} ${
                    errors.patientBirth ? styles.validationError : ''
                  }`}
                >
                  <input
                    placeholder="19800101"
                    type="text"
                    className={`${styles.normalInput}`}
                    {...register('patientBirth', {
                      value: '',
                      required: { value: true, message: t('questionnaire.58') },
                      onChange: (e) => {
                        let value = e.currentTarget.value;
                        if (isNaN(Number(e.currentTarget.value)))
                          setValue('patientBirth', value);
                      },
                      onBlur: (e) => {
                        setValue('patientBirth', watch().patientBirth.trim());
                      },
                    })}
                  />
                  {/* <span className={styles.inputUnit}>years old</span> */}
                </div>
              </label>

              <label className={styles.label}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>{t('questionnaire.5')}</span>
                </div>
                <div
                  className={`${styles.inputWrap} ${
                    errors.patientHeight ? styles.validationError : ''
                  }`}
                >
                  <input
                    type="text"
                    className={`${styles.normalInput} height`}
                    {...register('patientHeight', {
                      value: '',
                      required: { value: true, message: t('questionnaire.46') },
                      onChange: (e) => {
                        let value = e.currentTarget.value;
                        if (isNaN(Number(e.currentTarget.value)))
                          setValue(
                            'patientHeight',
                            value.slice(0, value.length - 1),
                          );
                      },
                      onBlur: (e) => {
                        setValue('patientHeight', watch().patientHeight.trim());
                      },
                    })}
                  />
                  <span className={styles.inputUnit}>cm</span>
                </div>
              </label>
              <label className={styles.label}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>{t('questionnaire.6')}</span>
                </div>
                <div
                  className={`${styles.inputWrap} ${
                    errors.patientWeight ? styles.validationError : ''
                  }`}
                >
                  <input
                    type="text"
                    className={`${styles.normalInput} weight`}
                    {...register('patientWeight', {
                      value: '',
                      required: {
                        value: true,
                        message: t('questionnaire.47'),
                      },
                      onChange: (e) => {
                        let value = e.currentTarget.value;
                        if (isNaN(Number(e.currentTarget.value)))
                          setValue(
                            'patientWeight',
                            value.slice(0, value.length - 1),
                          );
                      },
                      onBlur: (e) => {
                        setValue('patientWeight', watch().patientWeight.trim());
                      },
                    })}
                    // value={patientWeight}
                    // onChange={(e) => {
                    //   let value = e.currentTarget.value;
                    //   if (isNaN(Number(e.currentTarget.value))) return;
                    //   setPatientWeight(value);
                    // }}
                    // onBlur={() => setPatientWeight((prev) => prev.trim())}
                  />
                  <span className={styles.inputUnit}>kg</span>
                </div>
              </label>
              <label className={`${styles.label} ${styles.reasonLabel}`}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>{t('questionnaire.7')}</span>
                </div>
                <div
                  className={`${styles.inputWrap} ${
                    errors.reason ? styles.validationError : ''
                  }`}
                >
                  <textarea
                    className={`${styles.reason} reason`}
                    {...register('reason', {
                      value: '',
                      required: {
                        value: true,
                        message: t('questionnaire.48'),
                      },
                    })}
                    placeholder="diet"
                  ></textarea>
                </div>
              </label>
              <div
                className={`${styles.pregnancyLabel} ${
                  errors.pregnancy ? styles.warning : ''
                }`}
                {...register('pregnancy', {
                  required: {
                    value: watch().pregnancy == undefined,
                    message: t('questionnaire.49'),
                  },
                })}
              >
                <div>
                  <span>*</span>
                  <span>{t('questionnaire.8')}</span>
                </div>
                <div
                  className={`${styles.customCheckBoxWrap} ${
                    watch().pregnancy ? styles.hit : ''
                  } pregnancy`}
                  onClick={() => setValue('pregnancy', true)}

                  // onClick={() => setPregnancy(true)}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>{t('questionnaire.9')}</span>
                </div>
                <div
                  className={`${styles.customCheckBoxWrap} ${
                    watch().pregnancy === false ? styles.hit : ''
                  }`}
                  onClick={() => setValue('pregnancy', false)}

                  // onClick={() => setPregnancy(false)}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>{t('questionnaire.10')}</span>
                </div>
              </div>
            </form>
          </div>
          <div className={`${styles.prescriptionDetailWrap}`}>
            <label
              className={`${styles.label} ${
                errors.dailyCoffee ? styles.warning : ''
              } dailyCoffee`}
              {...register('dailyCoffee', {
                value: 0,
                validate: () =>
                  !/^[1-9]$/g.test(watch().dailyCoffee)
                    ? t('questionnaire.50')!
                    : true,
              })}
            >
              <div className={styles.labelWrap}>
                <span>*</span>
                <span>{t('questionnaire.11')}</span>
              </div>
              <ul className={styles.checkboxArea}>
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().dailyCoffee == 1 ? styles.hit : ''
                  }`}
                  onClick={() => setValue('dailyCoffee', 1)}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>{t('questionnaire.12')}</span>
                </li>
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().dailyCoffee == 2 ? styles.hit : ''
                  }`}
                  onClick={() => setValue('dailyCoffee', 2)}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>{t('questionnaire.13')}</span>
                </li>
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().dailyCoffee == 3 ? styles.hit : ''
                  }`}
                  onClick={() => setValue('dailyCoffee', 3)}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>{t('questionnaire.14')}</span>
                </li>
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().dailyCoffee == 4 ? styles.hit : ''
                  }`}
                  onClick={() => setValue('dailyCoffee', 4)}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>{t('questionnaire.15')}</span>
                </li>
              </ul>
            </label>
            <label
              className={`${styles.label} ${styles.caffeineSensitivity} ${
                errors.caffeineSensitivity ? styles.warning : ''
              } caffeineSensitivity`}
              {...register('caffeineSensitivity', {
                value: 0,
                validate: () =>
                  !/^[1-9]$/g.test(watch().caffeineSensitivity)
                    ? t('questionnaire.51')!
                    : true,
              })}
            >
              <div className={styles.labelWrap}>
                <span>*</span>
                <span>{t('questionnaire.16')}</span>
              </div>
              <ul className={styles.checkboxArea}>
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().caffeineSensitivity == 1 ? styles.hit : ''
                  }`}
                  onClick={() => setValue('caffeineSensitivity', 1)}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>{t('questionnaire.17')}</span>
                </li>
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().caffeineSensitivity == 2 ? styles.hit : ''
                  }`}
                  onClick={() => setValue('caffeineSensitivity', 2)}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>{t('questionnaire.18')}</span>
                </li>
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().caffeineSensitivity == 3 ? styles.hit : ''
                  }`}
                  onClick={() => setValue('caffeineSensitivity', 3)}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>{t('questionnaire.19')}</span>
                </li>
              </ul>
            </label>
            <label
              className={`${styles.label} ${
                errors.dietPillsExperience ? styles.warning : ''
              } dietPillsExperience`}
              {...register('dietPillsExperience', {
                value: [false, false, false, false],
                validate: () =>
                  watch().dietPillsExperience &&
                  !watch().dietPillsExperience.includes(true)
                    ? t('questionnaire.52')!
                    : true,
              })}
            >
              <div className={styles.labelWrap}>
                <span>*</span>
                <span>{t('questionnaire.20')}</span>
              </div>
              <ul className={styles.checkboxArea}>
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().dietPillsExperience &&
                    watch().dietPillsExperience[0]
                      ? styles.hit
                      : ''
                  }`}
                  onClick={() => {
                    setValue('dietPillsExperience', [
                      true,
                      false,
                      false,
                      false,
                    ]);
                    setValue('dietPillsLevel', 0);
                  }}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>{t('questionnaire.17')}</span>
                </li>
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().dietPillsExperience &&
                    watch().dietPillsExperience[1]
                      ? styles.hit
                      : ''
                  }`}
                  onClick={() => {
                    setValue('dietPillsExperience', [
                      false,
                      !watch().dietPillsExperience[1],
                      watch().dietPillsExperience[2],
                      watch().dietPillsExperience[3],
                    ]);
                  }}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>{t('questionnaire.21')}</span>
                </li>
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().dietPillsExperience &&
                    watch().dietPillsExperience[2]
                      ? styles.hit
                      : ''
                  }`}
                  onClick={() => {
                    setValue('dietPillsExperience', [
                      false,
                      watch().dietPillsExperience[1],
                      !watch().dietPillsExperience[2],
                      watch().dietPillsExperience[3],
                    ]);
                  }}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>{t('questionnaire.22')}</span>
                </li>
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().dietPillsExperience &&
                    watch().dietPillsExperience[3]
                      ? styles.hit
                      : ''
                  }`}
                  onClick={() => {
                    setValue('dietPillsExperience', [
                      false,
                      watch().dietPillsExperience[1],
                      watch().dietPillsExperience[2],
                      !watch().dietPillsExperience[3],
                    ]);
                  }}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>{t('questionnaire.23')}</span>
                </li>
              </ul>
            </label>
            {watch().dietPillsExperience &&
              !watch().dietPillsExperience[0] &&
              watch().dietPillsExperience.includes(true) && (
                <>
                  <label
                    className={`${styles.label} ${
                      errors.dietPillsLevel ? styles.warning : ''
                    } dietPillsLevel`}
                    {...register('dietPillsLevel', {
                      value: 0,
                      validate: () =>
                        !/^[1-9]$/g.test(watch().dietPillsLevel)
                          ? t('questionnaire.53')!
                          : true,
                      // required: {
                      //   value:
                      //     watch().dietPillsExperience &&
                      //     !watch().dietPillsExperience[0] &&
                      //     true,
                      //   message: '복용 약 단계 및 강도를 선택해주세요.',
                      // },
                    })}
                  >
                    <div className={styles.labelWrap}>
                      <span>*</span>
                      <span>{t('questionnaire.24')}</span>
                    </div>
                    <ul className={styles.checkboxArea}>
                      <li
                        className={`${styles.customCheckBoxWrap} ${
                          watch().dietPillsLevel == 1 ? styles.hit : ''
                        }`}
                        onClick={() => setValue('dietPillsLevel', 1)}
                      >
                        <div className={styles.customCheckBox}></div>
                        <span>{t('questionnaire.25')}</span>
                      </li>
                      <li
                        className={`${styles.customCheckBoxWrap} ${
                          watch().dietPillsLevel == 2 ? styles.hit : ''
                        }`}
                        onClick={() => setValue('dietPillsLevel', 2)}
                      >
                        <div className={styles.customCheckBox}></div>
                        <span>{t('questionnaire.26')}</span>
                      </li>
                      <li
                        className={`${styles.customCheckBoxWrap} ${
                          watch().dietPillsLevel == 3 ? styles.hit : ''
                        }`}
                        onClick={() => setValue('dietPillsLevel', 3)}
                      >
                        <div className={styles.customCheckBox}></div>
                        <span>{t('questionnaire.27')}</span>
                      </li>
                      <li
                        className={`${styles.customCheckBoxWrap} ${
                          watch().dietPillsLevel == 4 ? styles.hit : ''
                        }`}
                        onClick={() => setValue('dietPillsLevel', 4)}
                      >
                        <div className={styles.customCheckBox}></div>
                        <span>{t('questionnaire.28')}</span>
                      </li>
                    </ul>
                  </label>
                  <label
                    className={`${styles.label} ${
                      errors.sideEffects ? styles.warning : ''
                    }`}
                  >
                    <div className={styles.labelWrap}>
                      <span>*</span>
                      <span>{t('questionnaire.29')}</span>
                    </div>
                    <div
                      className={`${styles.inputWrap} ${
                        errors.sideEffects ? styles.validationError : ''
                      }`}
                    >
                      <textarea
                        className={`${styles.sideEffects} sideEffects`}
                        {...register('sideEffects', {
                          value: '',
                          required: {
                            value:
                              watch().dietPillsExperience &&
                              !watch().dietPillsExperience[0] &&
                              true,
                            message: t('questionnaire.54'),
                          },
                        })}
                      ></textarea>
                    </div>
                  </label>
                </>
              )}
          </div>
          <div
            className={`${styles.diseaseCheckWrap} ${
              errors.disease ? styles.warning : ''
            } disease`}
            {...register('disease', {
              required: {
                value: watch().disease == undefined,
                message: t('questionnaire.55'),
              },
            })}
          >
            <div className={styles.checkArea}>
              <div>
                <span>*</span>
                <span>{t('questionnaire.30')}</span>
              </div>
              <div
                className={`${styles.customCheckBoxWrap} ${
                  watch().disease ? styles.hit : ''
                }`}
                onClick={() => setValue('disease', true)}
              >
                <div className={styles.customCheckBox}></div>
                <span>{t('questionnaire.9')}</span>
              </div>
              <div
                className={`${styles.customCheckBoxWrap} ${
                  watch().disease === false ? styles.hit : ''
                }`}
                onClick={() => setValue('disease', false)}
              >
                <div className={styles.customCheckBox}></div>
                <span>{t('questionnaire.10')}</span>
              </div>
            </div>
            {watch().disease && (
              <>
                <span className={styles.sectionGuide}>
                  {t('questionnaire.31')}
                </span>
                <textarea
                  // placeholder="예) 불면증, 당뇨"
                  {...register('diseaseDetail', { value: '' })}
                />
              </>
            )}
          </div>
          <div
            className={`${styles.medicineCheckWrap} ${
              errors.medicine ? styles.warning : ''
            } medicine`}
            {...register('medicine', {
              required: {
                value: watch().medicine == undefined,
                message: t('questionnaire.56'),
              },
            })}
          >
            <div className={styles.checkArea}>
              <div>
                <span>*</span>
                <span>{t('questionnaire.32')}</span>
              </div>
              <div
                className={`${styles.customCheckBoxWrap} ${
                  watch().medicine ? styles.hit : ''
                }`}
                onClick={() => setValue('medicine', true)}
                // onClick={() => setMedicine(true)}
              >
                <div className={styles.customCheckBox}></div>
                <span>{t('questionnaire.9')}</span>
              </div>
              <div
                className={`${styles.customCheckBoxWrap} ${
                  watch().medicine === false ? styles.hit : ''
                }`}
                onClick={() => setValue('medicine', false)}
              >
                <div className={styles.customCheckBox}></div>
                <span>{t('questionnaire.10')}</span>
              </div>
            </div>
            {watch().medicine && (
              <>
                <span className={styles.sectionGuide}>
                  {t('questionnaire.33')}
                </span>
                <textarea
                  placeholder=""
                  // value={medicineDetail}
                  // onChange={(e) => setMedicineDetail(e.currentTarget.value)}
                  {...register('medicineDetail', { value: '' })}
                />
              </>
            )}
          </div>
          <div
            className={`${styles.cautionWrap} ${
              errors.cautionCheck ? styles.isError : ''
            }`}
          >
            <div className={styles.labelWrap}>
              <span>*</span>
              <span>{t('questionnaire.36')}</span>
            </div>
            <ul>
              <li>{t('questionnaire.37')}</li>
              <li>{t('questionnaire.38')}</li>
              <li>{t('questionnaire.39')}</li>
            </ul>
            <div
              className={`${styles.confirm} ${
                watch().cautionCheck ? styles.hit : ''
              }`}
              {...register('cautionCheck', {
                value: false,
                required: {
                  value: watch().cautionCheck == false,
                  message: t('questionnaire.57'),
                },
              })}
              onClick={() => setValue('cautionCheck', !watch().cautionCheck)}
            >
              <div className={styles.customCheckBox}></div>
              <span>{t('questionnaire.40')}</span>
            </div>
          </div>
          <button
            className={styles.submitBtn}
            onClick={handleSubmit(onSubmit, onSubmitError)}
          >
            {t('questionnaire.34')}
          </button>
        </div>
        {/* <div className={styles.right}>결제페이지로 이동</div> */}
      </div>
    </div>
  );
}
export default Questionnaire;
